import React, { useState, useEffect } from 'react';
import './ViewPageUser.css';
import { Text, Grid, Table, TextField, TableHead, TableBody, Button, Icon, Alert, ScrollView, TableRow, TableCell, useTheme } from '@aws-amplify/ui-react';
import { generateClient } from 'aws-amplify/api';
import { MdEdit, MdClose, MdOutlineRemoveCircleOutline, MdDeleteOutline } from 'react-icons/md';
import UpdateUserForm from './UpdateUserForm';
import { Loader } from '@aws-amplify/ui-react';
import { getUserByUsernameWithProjects } from '../custom_queries';
import { deleteUserProject, deleteUser } from '../graphql/mutations';
import { userProjectsByProjectIdAndUserId } from '../graphql/queries';
import ConfirmView from '../commons/ConfirmView';
import { listUserProjects } from '../graphql/queries';
import { deleteCognitoUser } from '../api/adminUsersApi';

const client = generateClient();

const ViewPageUser = ({ selectUser, onCancel }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('Cliente');
    const [projects, setProjects] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [isView, setIsView] = useState(true);
    const [user, setUser] = useState({});
    const [isTemporal, setIsTemporal] = useState(true);
    const [selectRemoveProject, setSelectRemoveProject] = useState({});
    const [isConfirmPopUp, setIsConfirmPopUp] = useState(false);
    const [temporalComponent, setTemporalComponent] = useState();
    const [isDelete, setIsDelete] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);

    const { tokens } = useTheme();

    useEffect(() => {
        // Función para obtener proyectos y actualizar el estado
        const fetchUserProjects = async () => {
            try {
                const userProjectsResult = await fetchProjects(selectUser.username);
                setProjects(userProjectsResult); // Actualiza el estado de proyectos
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };
        fetchUserProjects();
        setUser(selectUser);
        setUsername(selectUser.username);
        setEmail(selectUser.email);
        setRole(selectUser.role);

    }, []);

    const handlerLoader = () => {
        setTimeout(() => {
            setIsTemporal(false);
        }, 1000);
        
        setTemporalComponent(
            <Loader
                variation="linear"
                emptyColor={tokens.colors.gray}
                filledColor={'#588292'}
            />)
    }

    const handlerMessage = () => {
        setIsTemporal(true);
        setTimeout(() => {
            setIsTemporal(false)
        }, 3000);
        setTemporalComponent(<><br />
            <Alert
                variation="success"
                heading="Usuario actualizado correctamente"
                height='50px'
                size={'large'}
                marginTop={'-3rem'}
            ></Alert>

            <br /></>)

    }

    const handlerTemporal = (type) => {
        if (type === 'message') {
            handlerMessage();
        }
        if (type === 'loader') {
            handlerLoader();
        }
    }

    useEffect(() => {
        handlerTemporal("loader");
    }, [projects]);

    const handlersOnCancel = () => {
        onCancel();
    }

    const handleSubmit = (userData) => {
        setUsername(userData.username);
        setEmail(userData.email);
        setUser(userData);
        handlerTemporal("message");
        setIsView(true);
    };

    const closeEditView = async () => {
        setIsView(true);
        setIsUpdate(false);
    };

    const handlerClickOnEdit = async () => {
        setIsView(false);
        setIsUpdate(true);
    };

    const fetchProjects = async (username) => {
        try {
            const response = await client.graphql({
                query: getUserByUsernameWithProjects,
                variables: {
                    username: username
                }
            });
            return response.data.getUserByUsername.items[0].projects.items;
        } catch (e) {
            console.log('Something went wrong', e);
            return [];
        }
    };

    const getUserProjectObject = async (project, user) => {
        try {
            const response = await client.graphql({
                query: userProjectsByProjectIdAndUserId,
                variables: {
                    projectId: project.project.id,
                    userId: {
                        eq: user.id
                    }
                }
            });
            return response.data.userProjectsByProjectIdAndUserId.items[0];
        } catch (e) {
            console.log('Error in remove project by user', e);
            return [];
        }

    }

    const handlerConfirmRemoveProject = async () => {
        const userProject = await getUserProjectObject(selectRemoveProject, user);
        try {
            const response = await client.graphql({
                query: deleteUserProject,
                variables: {
                    input: {
                        id: userProject.id
                    },
                    condition: {
                        projectId: { eq: userProject.projectId },
                        userId: { eq: userProject.userId }
                    }
                }
            });
            setIsConfirmPopUp(false);
            handlerTemporal('message');
            console.log('User project remove Success');

            const fetchUserProjects = async () => {
                try {
                    const userProjectsResult = await fetchProjects(selectUser.username);
                    setProjects(userProjectsResult); // Actualiza el estado de proyectos
                } catch (error) {
                    console.error('Error fetching projects:', error);
                }
            };
            fetchUserProjects();

            return response;
        } catch (e) {
            const message = 'No se ha podido remover el proyecto 1'
            handlerError(message);
            console.log('Error in remove project by user', e);
            return [];
        }

    }

    const handlerRemoveProject = async (project) => {
        setIsConfirmPopUp(true);
        setSelectRemoveProject(project);
    }

    const handlerCancelRemoveProject = async () => {
        setIsConfirmPopUp(false);
    }

    const handlerError = (message) => {
        setIsConfirmPopUp(false);
        setErrorMessage(message);
        setIsError(true);
    }

    const handleDeleteUser = async () => {
        setIsError(false);
        setErrorMessage('');
        setIsView(false);
        setIsDelete(true);
    };

    const handlerCancelRemoveUser = async () => {
        setIsView(true);
        setIsDelete(false);
    };

    const getListUserProjects = async (userId) => {
        try {
            const response = await client.graphql({
                query: listUserProjects,
                variables: {
                    filter: {
                        userId: {eq: userId}
                    }
                }

            });
            return response;
        } catch (e) {
            console.log('Error in userProjects Query', e);
            return [];
        }

    }

    const deleteUserFromCognito = async (username) => {
        const response = await deleteCognitoUser({ username });
        console.log(`User '${username}' deleted successfully from Cognito`);
        return response;
    };

    const handlerConfirmRemoveUser= async () => {
        setIsError(false);
        setErrorMessage('');
        try {
            await deleteUserFromCognito(selectUser.username);
            const userProjectList = await getListUserProjects(selectUser.id);
            const items = userProjectList['data']['listUserProjects']['items'];

            for (let item of items) {
                await client.graphql({
                    query: deleteUserProject,
                    variables: {
                        input: {
                            id: item.id
                        }
                    }
                });
            }

            const responseDeleteUser = await client.graphql({
                query: deleteUser,
                variables: {
                    input: {
                        id: selectUser.id
                    }
                }
            });
            setIsDelete(false);
            setIsView(true);
            handlerTemporal('message');

            setTimeout(() => {
                handlersOnCancel();
            }, 3000);

            console.log('Project removed Success');
            return responseDeleteUser;
        } catch (e) {
            console.error('Error in remove user', e);
            const message = e?.message || 'No se ha podido remover el proyecto 2';
            handlerError(message);
            return [];
        }

    }

    return (
        <>

            {isView ? (
                <>
                    <Grid
                        templateColumns="5fr 1fr"
                        templateRows="2rem"
                    >
                        <Button
                            variation="primary"
                            colorTheme="success"
                            onClick={handlersOnCancel}
                            className='button-back'
                        >
                            <Icon
                                as={MdClose} aria-hidden="true"
                            />
                        </Button>
                        <Grid
                            templateColumns="10fr 1fr"
                            templateRows="2rem">
                            <Button
                                variation="primary"
                                colorTheme="success"
                                onClick={handlerClickOnEdit}
                                className='button-back'
                                title='Editar usuario'
                            >
                                <Icon as={MdEdit} aria-hidden="true" />
                            </Button>
                            <Button
                                variation="primary"
                                colorTheme="success"
                                onClick={handleDeleteUser}
                                className='button-back'
                                title='Asignar un proyecto'
                            >
                                <Icon as={MdDeleteOutline} aria-hidden="true" />
                            </Button>
                        </Grid>
                    </Grid>
                    {isTemporal ? (
                        <Grid
                            templateColumns="10fr"
                            templateRows="12rem"
                        >
                            <div>

                            </div>
                            {/* <Loader
                                variation="linear"
                                emptyColor={tokens.colors.gray}
                                filledColor={'#588292'}
                            /> */}
                            {temporalComponent}
                        </Grid>
                    ) :
                        (
                            <>
                                <Grid
                                    templateColumns="1.6fr 1fr"
                                    templateRows="4rem"
                                >
                                    <div className='div-text'>
                                        <Text className="labels-titles">Nombre de usuario</Text>
                                        <Text className="values">{username}</Text>

                                    </div>
                                    <div className='div-text'>
                                        <Text className="labels-titles">Role</Text>
                                        <Text className="values">{role}</Text>
                                    </div>
                                </Grid>
                                <div className='div-text'>
                                    <Text className="labels-titles">Correo electrónico</Text>
                                    <TextField className='values'
                                        defaultValue={email}
                                        isReadOnly={true}
                                        size="small"
                                        variation="quiet"
                                    />
                                </div>

                                <Grid
                                    templateColumns="10fr"
                                    templateRows="1.5rem"
                                >
                                    {(isConfirmPopUp) ? (
                                        <>
                                            <ConfirmView
                                                name={selectRemoveProject.project.name}
                                                handlerCancel={handlerCancelRemoveProject}
                                                handlerConfirm={handlerConfirmRemoveProject}
                                                type={'projectFromUser'}
                                            />
                                        </>) : (
                                        <>
                                            <div className='div-text'>
                                                <Text className="labels-titles-projects">Proyectos Asignados</Text>
                                            </div>
                                            <div className='div-text'>
                                                {projects.length > 0 ? (
                                                    <>
                                                        <ScrollView height="136px" width="450px" maxWidth="100%">
                                                            <Table
                                                                caption=""
                                                                highlightOnHover={false}
                                                                size="small"
                                                                variation="striped"
                                                                className='table-projects-in-user'>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell as="th" colSpan="3">Nombre</TableCell>
                                                                        <TableCell as="th">Quitar</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {projects.map((obj, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell
                                                                                colSpan="3"
                                                                            >{obj.project.name}</TableCell>
                                                                            <TableCell
                                                                            >
                                                                                <Button
                                                                                    variation="primary"
                                                                                    colorTheme="warning"
                                                                                    // onClick={handleuserPageToForm}
                                                                                    className='button-table'
                                                                                    title='Remover Proyecto a este usuario'
                                                                                    onClick={() => handlerRemoveProject(obj)}
                                                                                >
                                                                                    <Icon
                                                                                        viewBox={{ width: 20, height: 20 }}
                                                                                        color="red"
                                                                                        as={MdOutlineRemoveCircleOutline} aria-hidden="true"
                                                                                    />
                                                                                </Button>

                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </ScrollView>
                                                    </>) : (
                                                    <Text
                                                        color='#901414ed'>
                                                        Este usuario no tiene proyectos asignados
                                                    </Text>)}

                                            </div>
                                        </>)}

                                </Grid>
                            </>
                        )
                    }
                </>
            ) : (
                <>
                    {isDelete && !isUpdate &&
                        <>
                            <ConfirmView
                                handlerCancel={handlerCancelRemoveUser}
                                handlerConfirm={handlerConfirmRemoveUser}
                                type={'user'}
                            />
                        </>
                    }
                    {isUpdate && !isDelete &&
                        <>
                            <UpdateUserForm
                                selectUser={user}
                                onCancel={closeEditView}
                                onUpdate={handleSubmit}
                            />
                        </>
                    }
                </>
            )}
            {isError &&
                <Alert
                    variation="error"
                    heading={errorMessage}
                    height='3rem'
                    isDismissible
                    marginBottom={'1rem'}
                    marginLeft={'1.7rem'}
                ></Alert>}
        </>
    );
};

export default ViewPageUser;
